'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite(tfa, kind, sites) {
  this.Mk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Mi = null;
  this.Mj = null;
  this.Mk = tfa;
  this.Mi = kind;
  this.Mj = sites;
}
export { $c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite as $c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite };
$p = $c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite;
/** @constructor */
function $h_Lpresto_types$proto$ConfigureTwoFactorAuthToSite() {
}
export { $h_Lpresto_types$proto$ConfigureTwoFactorAuthToSite as $h_Lpresto_types$proto$ConfigureTwoFactorAuthToSite };
$h_Lpresto_types$proto$ConfigureTwoFactorAuthToSite.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("ConfigureTwoFactorAuthToSite"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.Mk;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Mi));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Mj));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 3);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite)) {
    var this$1 = this.Mk;
    var b = x$0.Mk;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var x = this.Mi;
      var x$2 = x$0.Mi;
      var $x_1 = (x === x$2);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Mj;
      var x$4 = x$0.Mj;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "ConfigureTwoFactorAuthToSite";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Mk;
      break;
    }
    case 1: {
      return this.Mi;
      break;
    }
    case 2: {
      return this.Mj;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToSite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kO)));
}
export { $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToSite as $isArrayOf_Lpresto_types$proto$ConfigureTwoFactorAuthToSite };
var $d_Lpresto_types$proto$ConfigureTwoFactorAuthToSite = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$ConfigureTwoFactorAuthToSite, "presto.types$proto$ConfigureTwoFactorAuthToSite", ({
  kO: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$ConfigureTwoFactorAuthToSite as $d_Lpresto_types$proto$ConfigureTwoFactorAuthToSite };
//# sourceMappingURL=presto.types$proto$-Configure-Two-Factor-Auth-To-Site.js.map
